import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PrismBetaIndicatorComponent,
	PrismButtonComponent,
	PrismCheckboxComponent,
	PrismIconComponent
} from '@shure/prism-angular-components';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

export interface InfoDialogData {
	title?: string;
	body?: string[];
	okLabel: string;
	showWarningIcon?: boolean;
	showBetaIcon?: boolean;
	doNotShowDialogId?: string;
}

@Component({
	selector: 'sh-info-dialog',
	templateUrl: './info-dialog.component.html',
	styleUrls: ['./info-dialog.component.scss'],
	imports: [
		CommonModule,
		FlexLayoutModule,
		MatDialogModule,
		PrismButtonComponent,
		TranslocoModule,
		PrismBetaIndicatorComponent,
		PrismCheckboxComponent,
		PrismIconComponent
	],
	providers: [provideInlineScope('scInfoDialog', (lang) => import(`../i18n/${lang}`))]
})
export class InfoDialogComponent {
	public doNotShowDialog = false;
	constructor(
		private readonly dialogRef: MatDialogRef<InfoDialogComponent, boolean>,
		@Inject(MAT_DIALOG_DATA) public readonly data: InfoDialogData
	) {}

	public toggleDoNotShowDialog(doNotShowDialog: boolean): void {
		this.doNotShowDialog = doNotShowDialog;
	}

	public close(): void {
		this.dialogRef.close(this.doNotShowDialog);
	}
}
